import { render, staticRenderFns } from "./PolicyXchange.vue?vue&type=template&id=16dcb188&"
import script from "./PolicyXchange.vue?vue&type=script&lang=js&"
export * from "./PolicyXchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports